
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Placement Team</h1>
                </div>
            </div>
        </div>			
    </div>
</section>  

 <section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">            
            <div class="col-md-4 col-sm-6">
                <div class="team" >
                    <figure><img class="img-fluid" src="assets/images/team/sandhya-pandey.webp" alt="Ms. Sandhya Pandey | Ghrcacsn" title="Ms. Sandhya Pandey | Ghrcacsn"> </figure>
                    <div class="team-details placement-team">
                        <h5>Ms. Sandhya Pandey</h5> 
                        <h6>Placement Officer</h6>                                 
                        <p><i class="fa fa-phone"></i> 8999935297/9923859824</p>  
                        <p><i class="fa fa-map-marker"></i> 2nd Floor Riaan Tower, MangalwariBazar road, Sadar, Nagpur-440001</p>              
                        <p><i class="fa fa-envelope"></i> sandhya.pandey@raisoni.net</p>                    
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-6">
                <div class="team" >
                    <figure><img class="img-fluid" src="assets/images/team/gurpal_singh.webp" alt="MR. Gurpal Singh | Ghrcacsn" title="MR. Gurpal Singh | Ghrcacsn"> </figure>
                    <div class="team-details placement-team">
                        <h5>MR. GURPAL SINGH</h5> 
                        <h6>Head Industry Relations</h6>       
                        <p><i class="fa fa-phone"></i> 7020440527/07104-236102</p>  
                        <p>EXT : 306</p>            
                        <p><i class="fa fa-envelope"></i> gurpal.singh@raisoni.net <br>rgiplacement@raisoni.net</p>                          
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-sm-6">
                <div class="team" >
                    <figure><img class="img-fluid"  src="assets/images/team/jyoti_pillay.webp" alt="Dr. Jyoti Pillay | Ghrcacsn" title="Dr. Jyoti Pillay | Ghrcacsn"> </figure>
                    <div class="team-details placement-team">
                        <h5>Dr. Jyoti Pillay </h5> 
                        <h6>Placement Co-ordinator</h6>  
                        <!-- <p><i class="fa fa-phone"></i> 9011056459</p>             -->
                        <p><i class="fa fa-envelope"></i> jyoti.pillay@raisoni.net</p>                               
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> 

